import { chakra, Table, Thead, Tbody, Td } from "@chakra-ui/react";
import { h4Apercu } from "theme/apercuHeadings";
import { space } from "theme/themeConfig";
import { fontVariants } from "../fontVariants";
import { textLinkStates } from "./link";

const { acuminRegular, acuminSemiBold, acuminLight } = fontVariants;

const fontTweak = {
  base: {
    fontSize: 1,
    lineHeight: 1
  },
  md: {
    fontSize: 2,
    lineHeight: 1
  }
};

const listStyles = {
  ml: space[1],
  li: {
    mt: { base: space[-2], md: space[1] }
  }
};

export const HtmlTable = chakra(Table, {
  baseStyle: {
    ...acuminLight,
    my: space["2"]
  }
});

export const HtmlTableThead = chakra(Thead, {
  baseStyle: {
    td: { ...h4Apercu }
  }
});

export const HtmlTableBody = chakra(Tbody, {
  baseStyle: {
    borderBottom: "none",
    verticalAlign: "top",
    ul: {
      listStyleType: `"- "`,
      ...listStyles
    },
    ol: {
      ...listStyles
    }
  }
});

export const HtmlTd = chakra(Td, {
  baseStyle: {
    padding: { base: space[-1], md: space[-5] },
    borderBottom: "none",
    verticalAlign: "middle",
    a: {
      ...textLinkStates
    }
  }
});

export const HtmlTableV2 = chakra(Table, {
  baseStyle: {
    ...acuminRegular,
    my: space["2"]
  }
});

export const HtmlTableTheadV2 = chakra(Thead, {
  baseStyle: {
    td: {
      base: { ...acuminSemiBold },
      md: { ...acuminSemiBold }
    }
  }
});

export const HtmlTableBodyV2 = chakra(Tbody, {
  baseStyle: {
    borderBottom: "none",
    verticalAlign: "top",
    ul: {
      listStyleType: `"- "`,
      ...listStyles
    },
    ol: {
      ...listStyles
    },
    td: { ...fontTweak }
  }
});

export const HtmlTdV2 = chakra(Td, {
  baseStyle: {
    padding: { base: space[-1], md: space[-5] },
    borderBottom: "none",
    verticalAlign: "middle",
    a: {
      fontSize: "1rem",
      textDecoration: "underline"
    }
  }
});
